import axiosConfig from '@/data/utils/axiosConfigInstance';
import { apiWrapper } from '@/data/utils/apiWrapper';

export const createAdvancedJumpsLead = payload => apiWrapper(axiosConfig.post('/promo/advanced-jumps/lead', payload));

export const resolveAdvancedJumpsLead = token =>
	apiWrapper(axiosConfig.get('/promo/advanced-jumps/resolve', { params: { token } }));

export const fetchPromoVideo = (token, promoVideo) =>
	apiWrapper(axiosConfig.get('/promo/advanced-jumps/video', { params: { token, promoVideo } }));
